import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { COMPANY_MICRO_SITE } from '../../../common';
import { Common } from '../../../common/common';
import { APP_FLOW, config } from '../../../common/constant';
import * as user from "../../../redux/actions/userAction";
import * as userActions from "../../../redux/actions/userAction";
import * as zakat from "../../../redux/actions/zakatActions";
import * as zakatCalc from "../../../redux/actions/zakatCalcAction";
import { fidyahActions } from "../../../redux/reducers/fidyah-slice";
import { getAppFlow } from '../../utils/app.utils';
import Pool from '../../../aws-pool/login-pool';
import { AccountContext } from '../../../aws-pool/Account';
import { withTranslation } from "react-i18next";
import { ICON_RECEIPT, TICK_CIRCLE_BIG, TICK_SUCCESS,TICK_SUCCESS_GRAPHIC } from '../../../common/images-s3';
import { kaffarahActions } from '../../../redux/reducers/kaffarah-slice';
import { donationWidgetActions } from '../../../redux/reducers/donationWidgetSlice';
import * as pledgeActions from "../../../redux/actions/pledgeActions";

const ImageLoader = lazy(() => import('../../../common/image-loader'));

class DonationEReceipt extends React.Component {
    static contextType = AccountContext;
    constructor(props) {
        super(props)

        this.appFlow = getAppFlow();

        this.state = {
            name: this.props.user.userData.fullname || this.props.user.userData.primaryname || '',
            email: this.props.user.userData.email ?? '-',
            phoneNumber: `${this.props.user.userData.countryCode} ${this.props.user.userData.mobile}`,
            transactionType: this.props.user.transactionType,
        }

        this.redirectToZakat = this.redirectToZakat.bind(this);
    }

    redirectToZakat() {
        sessionStorage.clear('token');

        // const user = Pool.getCurrentUser();

        // if (user) {
        //     this.props.dispatch(zakat.resetFitrahData());
        //     this.props.dispatch(zakat.resetZakatData());
        //     this.props.dispatch(zakatCalc.resetZakatCalcData());
        //     this.props.dispatch(donationWidgetActions.reset());
        //     this.props.dispatch(fidyahActions.reset());
        //     this.props.dispatch(kaffarahActions.reset());
        // } else {
        //     Common.resetData();
        // }

        if (window.location.href.search(/fidyah/gi) !== -1) {
            window.location.href = window.location.origin + '/fidyah';
        } else if (window.location.href.search(/kaffarah/gi) !== -1) {
            window.location.href = window.location.origin + '/kaffarah';
        } else if (window.location.href.search(/wms/gi) !== -1) {
            window.location.href = window.location.origin + '/wms';
        } else if (window.location.href.search(/ilmu/gi) !== -1 || (window.location.href.search(/wakaf/gi) !== -1 && !window.location.pathname.includes('pledging'))) {
            window.location.href = window.location.origin + '/wakaf-ilmu';
        } else if (window.location.href.search(/pledging/gi) !== -1) {
            window.location.href = window.location.origin + '/pledging';
        }
         else {
            window.location.href = window.location.origin;
        }
    }

    componentDidMount() {
        this.appFlow = getAppFlow();

        this.setState({
            transactionType: this.props.user.transactionType,
            name: this.props.user.isBusinessPayer ? this.props.user.userData.representativeName : this.props.user.userData.fullname || this.props.user.userData.primaryname || '',
            email: this.props.user.isBusinessPayer ? this.props.user.userData.corporateEmail : this.props.user.userData.email ?? '-',
            phoneNumber: this.props.user.userData.phoneNumber,
        })

        this.props.dispatch(user.updateTransactionStatus(true));
        this.props.dispatch(user.updateIRASInclusion(null));
        this.props.dispatch(user.updateIsOthers(null));
        this.props.dispatch(user.updateBusinessUser(null));
        this.props.dispatch(user.updateIsDeceased(null));

        const { getSession } = this.context;
        Pool.getCurrentUser() && getSession()
        .then(data => {
            const countryCode = data['custom:COUNTRY_CODE'] ?? '+65';
            let mobileNumber = data?.phone_number ?? '';

            if (Boolean(mobileNumber) && Boolean(countryCode)) {
                mobileNumber = mobileNumber.replace(countryCode, '').match(/.{1,4}/g).join(' ');
                mobileNumber = mobileNumber.replace(/\d{4}(?=.)/g, '$& ');
            }

            const userData = {
                countryCode: countryCode ?? '',
                mobile: mobileNumber ?? '',
                registeredAddress: data.address ?? '',
                uen: data['custom:UEN'] ?? '',
                nric: data['custom:NRIC'] ?? '',
                companyName: data['custom:COMPANY_NAME'] ?? '',
                isBusinessAccount: data['custom:BUSINESS_ACC'] ?? '',
                email: data['email'] ?? '',
                representativeName: (data['custom:BUSINESS_ACC'] === "Yes" || data['custom:BUSINESS_ACC'] === true) ? data['name'] : '',
                name: (data['custom:BUSINESS_ACC'] === "Yes" || data['custom:BUSINESS_ACC'] === true) ? data['name'] : data['name'],
                nationality: this.props.user.userData.nationality || "",
                countryofbirth: this.props.user.userData.countryofbirth || "",
                dateofbirth: this.props.user.userData.dateofbirth || "",
            };

            this.props.dispatch(userActions.updateUserData({ ...userData }));
        });
        if (this.appFlow === APP_FLOW.PLEDGE) {
            document.body.scrollTop = 0;
        }
    }

    componentWillUnmount() {
        sessionStorage.clear('token');
        setTimeout(() => {
            const user = Pool.getCurrentUser();

            if (user) {
                this.props.dispatch(zakat.resetFitrahData());
                this.props.dispatch(zakat.resetZakatData());
                this.props.dispatch(zakatCalc.resetZakatCalcData());
                this.props.dispatch(fidyahActions.reset());
                this.props.dispatch(donationWidgetActions.reset());
                this.props.dispatch(kaffarahActions.reset());
                this.props.dispatch(pledgeActions.resetPledgeData())
            } else {
                Common.resetData();
            }
        }, 10);

        // setTimeout(()=>{
        if (window.location.pathname === "/calculator") {
            this.props.history.push("/");
        }
        // }, 0);
    }

    render() {
        const { t } = this.props;

        const DoaZakat = 'images/video/Doa.mp4';

        if (this.state.transactionType === "fidyah" || this.appFlow === APP_FLOW.FIDYAH || this.appFlow === APP_FLOW.KAFFARAH) {
            return (
                <>
                    {
                        // this.props.user.userData?.flow?.toString().toLowerCase() === 'anonymous' ?
                        //     <div className="c-donation-e-receipt fidyah anonymous">
                        //         <div className="c-img">
                        //             <img className='right-logo' src={ICON_RECEIPT} alt="receipt-svg" />
                        //         </div>
                        //         <div className='c-recite-dua'>
                        //             <p className='des' dangerouslySetInnerHTML={{ __html: `${t('Fidyah_anonymous_contribution_text')}` }}></p>
                        //         </div>
                        //         <button onClick={this.redirectToZakat} className="btn btn-light">{t('BTN_GO_HOME')}</button>
                        //     </div>
                        //     :
                            <div className="c-donation-e-receipt fidyah">
                                <div className="c-img">
                                    <img className='right-logo' src={ICON_RECEIPT} alt="receipt-svg" />
                                </div>
                                <div className='c-recite-dua'>
                                    { 
                                        Boolean(this.state.name) && 
                                            <h4 className='title' dangerouslySetInnerHTML={{ __html: `${t('Fidyah_thank_you')}, ${this.state.name}` }}></h4>
                                    }
                                    <h4 className='title' dangerouslySetInnerHTML={{ __html: `${t('Fidyah_receipt_sent_text')}` }}></h4>
                                    <p className='user-email'>{`${this.state.email}`}</p>

                                    {(this.props.user.userData?.accountCreated) && <>
                                        <div className='line'></div>
                                        <div className='c-ac-success'>
                                            <Suspense fallback={null}>
                                                <ImageLoader type="image" src={TICK_CIRCLE_BIG}></ImageLoader>
                                            </Suspense>
                                            <span>{t('Account_success_label3')}</span>
                                        </div>
                                    </>
                                    }

                                    <p className='des' dangerouslySetInnerHTML={{ __html: `${t('Fidyah_thank_you_contribution_text')}` }}></p>
                                </div>
                                <button onClick={this.redirectToZakat} className="btn btn-light">{t('BTN_GO_HOME')}</button>
                            </div>
                    }
                </>
            );
        } else if (this.appFlow === APP_FLOW.ILMU || this.appFlow === APP_FLOW.WMS) {
           return (
                <>
                    {<div className="c-donation-e-receipt fidyah wakaf_donation">
                        <div className="c-img">
                            <img className='right-logo' src={ICON_RECEIPT} alt="receipt-svg" />
                        </div>
                        <div className='c-recite-dua'>
                            { 
                                Boolean(this.state.name) && 
                                    <h4 className='title' dangerouslySetInnerHTML={{ __html: `${t('Fidyah_thank_you')}, ${this.state.name}` }}></h4>
                            }
                            <h4 className='title' dangerouslySetInnerHTML={{ __html: `${t('Wakaf_Donation')}` }}></h4>
                            <p className='user-email'>{`${this.state.email}`}</p>

                            {(this.props.user.userData?.accountCreated) && <>
                                <div className='line'></div>
                                <div className='c-ac-success'>
                                    <Suspense fallback={null}>
                                        <ImageLoader type="image" src={TICK_CIRCLE_BIG}></ImageLoader>
                                    </Suspense>
                                    <span>{t('Account_success_label3')}</span>
                                </div>
                            </>
                            }
                            {this.appFlow === APP_FLOW.ILMU ? 
                                <p className='des' dangerouslySetInnerHTML={{ __html: `${t('Wakaf_thank_you_contribution_text') + '<br/>' + t('Receipt_label1')}` }}></p>
                            : 
                                <p className='des' dangerouslySetInnerHTML={{ __html: `${t('Wakaf_Wms_thank_you_contribution_text') + '<br/>' + t('Receipt_label1')}` }}></p>
                            }
                        </div>
                        <button onClick={this.redirectToZakat} className="btn btn-light">{t('BTN_GO_HOME')}</button>
                    </div>}
                </>
            )
        } else if (this.appFlow === APP_FLOW.PLEDGE) {
            return (
                 <>
                     {<div className="c-donation-e-receipt fidyah wakaf_donation pledge-thank-you-pg thank-you-details">
                        <div className="c-success">
                            <div className="c-img">
                                <div className="c-tick-img">
                                    <Suspense fallback={null}>
                                        <ImageLoader type="image" src={TICK_CIRCLE_BIG}></ImageLoader>
                                    </Suspense>
                                </div>
                                <div className='grphic-img'>
                                    <Suspense fallback={null}>
                                        <ImageLoader type="image" src={TICK_SUCCESS_GRAPHIC}></ImageLoader>
                                    </Suspense>
                                </div>
                            </div>
                        </div>
                         <div className='c-recite-dua'>
                             { 
                                 Boolean(this.state.name) && 
                                     <h4 className='title' dangerouslySetInnerHTML={{ __html: `${t('Pledge_thank_you')}` }}></h4>
                             }
                             {/* <h4 className='title' dangerouslySetInnerHTML={{ __html: `${t('Wakaf_Donation')}` }}></h4> */}
                             <p className='user-email'>{`${this.state.email}`}</p>
                             <p className='des' dangerouslySetInnerHTML={{ __html: `${t('Pledge_contribution_text')}` }}></p>

                             {(this.props.user.userData?.accountCreated) && <>
                                 <div className='line'></div>
                                 <div className='c-ac-success'>
                                     <Suspense fallback={null}>
                                         <ImageLoader type="image" src={TICK_CIRCLE_BIG}></ImageLoader>
                                     </Suspense>
                                     <span className='mb-0'>{t('Account_success_label3')}</span>
                                 </div>
                             </>
                             }
                            
                         </div>
                         <button onClick={this.redirectToZakat} className="btn btn-light">{t('BTN_GO_HOME')}</button>
                     </div>}
                 </>
             )
         }

        return (
            <div className="c-donation-e-receipt">
                <div className='c-recite-dua'>
                    <h4 className='title' dangerouslySetInnerHTML={{ __html: t('Thank_you_text') }}></h4>
                    {this.state.email && <p className='user-email'>{t('Thank_you_text1')} <br /> {this.state.email}</p>}
                    <p className='des' dangerouslySetInnerHTML={{ __html: t("Thank_you_receipt_dua") }}></p>
                    {/* <iframe src={config.PAYMENT_THANK_YOU_VIDEO} crossOrigin='true' className='recite-dua' title='recite-dua-url'></iframe> */}
                    <div className='recite-dua'>
                        <Suspense fallback={null}>
                            <ImageLoader src={DoaZakat} type='video' controls={'controls'} muted={true} />
                        </Suspense>
                    </div>
                    {/* <video width="320" height="240" controls autoplay>
                        <source src={DoaZakat} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video> */}
                    <div className='c-dua-zakat'>
                        <p className='one'>آجَرَكَ اللهُ فِيْمَا اَعْطَيْتَ، وَبَارَكَ اَللهُ لَكَ فِيْمَا اَنْفَقْتَ وَجَعَلَهُ لَكَ طَهُوْرًا</p>
                        <p className='two'>Ajarakallahu fiimaa a'thoita wa baarakallahu laka fiimaa anfaqta waja'alahu laka thohuuron.</p>
                        <p className='three'>{t('Thank_you_receipt_dua_text')}</p>
                    </div>
                    {this.props.user.userData?.accountCreated &&
                        <div className='c-ac-success'>
                            <Suspense fallback={null}>
                                <ImageLoader type="image" src={TICK_SUCCESS}></ImageLoader>
                            </Suspense>
                            <span>{t('Account_success_label3')}</span>
                        </div>
                    }
                </div>
                <button onClick={this.redirectToZakat} className="btn btn-light">{t('BTN_GO_HOME')}</button>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.userReducer
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(DonationEReceipt)));